module.exports = __webpack_public_path__ + "img/banner-fabrica.545352fb.jpg";